// extracted by mini-css-extract-plugin
export default {"ThumbnailCategories":"ThumbnailCategories_ThumbnailCategories__BcrdW","Img":"ThumbnailCategories_Img__iLo2h","Txt":"ThumbnailCategories_Txt__50aie"};